import { withApollo } from '@apollo/client/react/hoc'
import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import { withRenderToasters } from 'utils/hoc/withRenderToasters'
import withRouterCustom from 'utils/hoc/withRouterCustom'
import { withMixpanel } from 'utils/sdks/mixpanel'

import { isAccountTypeRetailer } from 'store/currentUser/selectors'
import { renderSuccessNotification } from 'store/notificationHandler/actions'
import { resetSelectedOrders } from 'store/orderList/actions'
import {
  resetSelectedStyleColors,
  toggleAllStyleColors,
  toggleStyleColor,
} from 'store/orderList/removeStyleColorsWithoutQuantities/actions'
import {
  getCountStyleColorsSelected,
  getCountUnselectedStyleColors,
  getSelectedStyleColors,
  isStyleColorSelected,
} from 'store/orderList/removeStyleColorsWithoutQuantities/selectors'
import { getSelectedOrdersIds } from 'store/orderList/selectors'

import { withAnalytics } from './RemoveStyleColorsWithoutQuantities.analytics'
import RemoveStyleColorsWithoutQuantities from './RemoveStyleColorsWithoutQuantities.component'
import { withCancelStyleColorsFromOrder } from './RemoveStyleColorsWithoutQuantities.mutations'
import { withOrders } from './RemoveStyleColorsWithoutQuantities.queries'

const mapStateToProps = (state) => ({
  selectedOrdersIds: getSelectedOrdersIds(state),
  isStyleColorSelected: isStyleColorSelected(state),
  countSelectedStyleColors: getCountStyleColorsSelected(state),
  selectedStyleColors: getSelectedStyleColors(state),
  countUnselectedStyleColors: getCountUnselectedStyleColors(state),
  isRetailer: isAccountTypeRetailer(state),
})

const mapDispatchToProps = {
  toggleAllStyleColors,
  toggleStyleColor,
  resetSelectedStyleColors,
  renderSuccessNotification,
  resetSelectedOrdersOrderListPage: resetSelectedOrders,
}

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  withOrders,
  withCancelStyleColorsFromOrder,
  withApollo,
  withMixpanel,
  withRouterCustom,
  withAnalytics,
  withRenderToasters,
)(RemoveStyleColorsWithoutQuantities)
